import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function KakobuySafetyGuide() {
  return <ArticleLayout content={allArticles[2]} />;
}